<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <div style="display: flex; justify-content: center; margin-bottom: 10px; margin-top: 10px">
        <div class="logo-image">
          <img :src="logo" alt="logo" />
        </div>
        <!-- <img style="width: 30%; height: auto; border-radius: 156px" :src="logo" /> -->
      </div>
      <div class="title-container">
        <h3 class="title">團體旅遊應用系統<br v-show="isMobile" />★後台管理 {{ environment }}</h3>
      </div>

      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          ref="username"
          v-model="loginForm.username"
          placeholder="帳號"
          name="username"
          type="text"
          tabindex="1"
          autocomplete="on"
        />
      </el-form-item>

      <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="密碼"
            name="password"
            tabindex="2"
            autocomplete="off"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
      </el-tooltip>

      <el-checkbox v-model="isRemember" style="right: 0px; position: absolute"
        >儲存密碼</el-checkbox
      >

      <el-button
        :loading="loading"
        type="primary"
        size="large"
        style="width: 100%; margin-bottom: 15px; font-size: 18px; margin-top: 30px"
        @click.native.prevent="handleLogin"
        >登入</el-button
      >

      <div style="line-height: 24px; max-height: 150px; overflow: auto">
        <template v-for="(item, index) in noticeList">
          <div
            v-html="item"
            style="line-height: 20px; font-size: 16px; margin: 5px 0px; color: red"
          ></div>
          <!-- <span style="line-height: 20px; font-size: 16px">
            {{ noticeList.length > 1 ? index + 1 + "." : "" }}{{ item }}
          </span> -->
        </template>
      </div>

      <!-- <div style="position:relative">
        <div class="tips">
          <span>Username : admin</span>
          <span>Password : any</span>
        </div>
        <div class="tips">
          <span style="margin-right:18px;">Username : editor</span>
          <span>Password : any</span>
        </div>

        <el-button class="thirdparty-button" type="primary" @click="showDialog=true">
          Or connect with
        </el-button>
      </div> -->
    </el-form>

    <div
      style="
        width: 520px;
        max-width: 100%;
        text-align: center;
        margin-top: 30px;
        margin-bottom: 30px;
      "
    >
      <!-- <img :src="logotext" style="width: 100%" /> -->
      <svg-icon class-name="ic_footerlogo" icon-class="ic_footerlogo" />
    </div>

    <el-dialog title="Or connect with" :visible.sync="showDialog">
      Can not be simulated on local, so please combine you own business simulation! ! !
      <br />
      <br />
      <br />
      <social-sign />
    </el-dialog>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'
import SocialSign from './components/SocialSignin'
import { getEnvironment } from '@/api/unity'
import applogo from '@/assets/images/logo3gtapp.png'
import logotext from '@/assets/images/logoText.png'
import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import { getRangeSysNotice } from '@/api/system'

export default {
  name: 'Login',
  components: { SocialSign },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.trim() == '') {
        callback(new Error('帳號輸入錯誤'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('請輸入密碼'))
      } else {
        callback()
      }
    }
    return {
      environment: '',
      loginForm: {
        username: '',
        password: '',
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      logo: applogo,
      logotext: logotext,
      isRemember: false,
      noticeList: [],
      isMobile: false,
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true,
    },
  },
  async created() {
    const body = document.body
    const rect = body.getBoundingClientRect()
    this.isMobile = rect.width - 1 < 992
    this.$store.dispatch('app/showDialog', false)

    if (process.env.NODE_ENV == 'development') {
      // this.loginForm.username = "0927373973";
      // this.loginForm.password = "ja$19840528";
    }
    // window.addEventListener('storage', this.afterQRScan)
    await getRangeSysNotice()
      .then(response => {
        console.log(response)
        response.data.forEach((element, index) => {
          console.log(element, index)
          if (response.data.length > 1) {
            element = index + 1 + '. ' + element
          }
          element = element.replace(/\n/g, '<br />')
          this.noticeList.push(element)
        })
        console.log(this.noticeList)
      })
      .catch()
    await this.getEnvironment()
  },
  mounted() {
    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }
    this.checkPassword()
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    async getEnvironment() {
      const res = await getEnvironment()

      if (res.success) {
        if (res.message == '正式環境') {
          this.environment = ''
        } else {
          this.environment = res.message
        }
      }
    },
    changeRemember(val) {
      if (val) {
        var str = this.encryp(this.loginForm.password)
        // CryptoJS.AES.encrypt(ruleForm.password,'user123!')
        Cookies.set('up', str, {
          expires: 30, // 存储30天
        })
      } else {
        Cookies.remove('up')
      }
    },
    //加密
    encryp(data) {
      if (typeof data === 'object') {
        // 如果傳入的data是json物件，先轉義為json字串
        try {
          data = JSON.stringify(data)
        } catch (error) {
          console.log('error:', error)
        }
      }
      // 統一將傳入的字串轉成UTF8編碼
      const dataHex = CryptoJS.enc.Utf8.parse(data) // 需要加密的資料
      const keyHex = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_KEY) // 祕鑰
      const ivHex = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_IV) // 偏移量
      const encrypted = CryptoJS.AES.encrypt(dataHex, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC, // 加密模式
        padding: CryptoJS.pad.Pkcs7,
      })
      let encryptedVal = encrypted.ciphertext.toString()
      return encryptedVal //  返回加密後的值
    },
    //解密
    decrypt(encryptedVal) {
      let encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedVal)
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
      const keyHex = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_KEY) // 祕鑰
      const ivHex = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_IV) // 偏移量
      let decrypt = CryptoJS.AES.decrypt(srcs, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      })
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
      return decryptedStr.toString()
    },
    checkPassword() {
      const enPassword = Cookies.get('up') ? Cookies.get('up') : ''
      if (enPassword) {
        // 对密码进行解密
        this.loginForm.password = this.decrypt(enPassword)
        this.isRemember = true
      } else {
        this.loginForm.password = ''
        this.isRemember = false
      }
    },
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z'
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('user/login', this.loginForm)
            .then(() => {
              this.changeRemember(this.isRemember)
              this.$router.push({
                path: this.redirect || '/',
                query: this.otherQuery,
              })
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    // afterQRScan() {
    //   if (e.key === 'x-admin-oauth-code') {
    //     const code = getQueryObject(e.newValue)
    //     const codeMap = {
    //       wechat: 'code',
    //       tencent: 'code'
    //     }
    //     const type = codeMap[this.auth_type]
    //     const codeName = code[type]
    //     if (codeName) {
    //       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
    //         this.$router.push({ path: this.redirect || '/' })
    //       })
    //     } else {
    //       alert('第三方登录失败')
    //     }
    //   }
    // }
  },
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$light_gray: #4b4b4b;
$cursor: #4b4b4b;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: gray;
      height: 47px;
      caret-color: $cursor;
      font-size: 16px;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px lightgray inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-input__inner::placeholder {
    color: gray;
  }

  /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: gray;
  }

  /* 火狐 */
  .el-input__inner:-moz-placeholder {
    color: gray;
  }

  /*ie*/
  .el-input__inner:-ms-input-placeholder {
    color: gray;
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: lightgray;
    border-radius: 5px;
    color: #454545;
    margin-bottom: 15px;
  }

  .el-button--primary {
    border-color: #fed465;
    background-color: #fed465;
    color: #4b4b4b;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #454545;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #fed465;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #fed465;
    background-color: #fed465;
  }
}
</style>

<style lang="scss" scoped>
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: white;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    // padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: #fed465;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  .ic_footerlogo {
    width: 154px;
    height: 70px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }

    .login-form {
      width: 90% !important;
    }
  }
}

// .circle-image {
//   width: 160px;
//   height: 160px;
//   border-radius: 50%;
//   overflow: hidden;
//   background: #FED465;
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   img {
//     width: 65%;
//     padding-bottom: 8px;
//     height: auto;
//   }
// }
.logo-image {
  width: 160px;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 65%;
    height: auto;
  }
}
</style>
